/* eslint-disable react/prop-types */
import { Box } from "@chakra-ui/react";
import { IDLE_TIMERS } from "App";
import { IdleTimer } from "common/IdleTimer";
import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import Header from "../../common/Header";
import UserBar from "../../common/UserBar";
import { _basePath } from "../../config/index";
import { UserContext } from "../../context";
import { useApiUser } from "../../context/ApiAuthContext";
import CheckInRules from "../CheckInRules";
import EventNavigation from "../EventNavigation";
import Fantastic from "../Fantastic";
import ScheduleRules from "../ScheduleRules";
import ConfirmAppointment from "../ConfirmAppointment";

export function CreateAppointment() {
  let { path } = useRouteMatch();
  const { customerName, tenantName } = useApiUser();
  const {
    userData: { user, loggedIn },
  } = React.useContext(UserContext);

  if (!loggedIn) return <Redirect to={_basePath} />;

  return (
    <>
      <Box layerStyle={"kioskSidebarLayout"}>
        <Header customerName={customerName} tenantName={tenantName} />
        <UserBar user={user} />
        <Box as={"main"} layerStyle={"kioskMain"}>
          <Switch>
            <Route exact path={`${path}/checkin`}>
              <IdleTimer idleTimerSecs={IDLE_TIMERS.CHECKIN} />
              <CheckInRules user={user} loggedIn={loggedIn} />
            </Route>
            <Route path={`${path}/events`}>
              <IdleTimer idleTimerSecs={IDLE_TIMERS.EVENT_NAV} />
              <EventNavigation />
            </Route>
            <Route path={`${path}/schedule`}>
              <IdleTimer idleTimerSecs={IDLE_TIMERS.RULES} />
              <ScheduleRules user={user} loggedIn={loggedIn} />
            </Route>
            <Route exact path={`${path}/confirm`}>
              <ConfirmAppointment />
            </Route>
            <Route exact path={`${path}/complete`}>
              <Fantastic />
            </Route>
          </Switch>
        </Box>
      </Box>
    </>
  );
}

CreateAppointment.displayName = "CreateAppointment";
export default CreateAppointment;
